// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3x-Tl","tab":"ProcedureTabs_tab__37pKJ"};